import { Component } from '@angular/core';
import { File } from './../../models/files/files.model';
import { CommunicationService } from './../../shared/services/communication.service';

import * as appConfig from './../../app.config';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-file-list',
  templateUrl: './file-list.component.html'
})
export class FileListComponent extends ListBase<File> {

  public downloadUrl = appConfig.apiUrl + 'files/download/';
  public url = 'files';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    )
  }

  public getBoxStyle(isImage: boolean, isResizable: boolean, file: string): any {

    if (isImage) {
      if (isResizable) {
        return {
          'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + '460x460_' + file + ')'
        };
      }
      return {
        'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + file + ')'
      };
    }

    return {};
  }


  public reloadList($event): void {
    this._getItems();
    this._getPaginationParams(this.q);
  }

  public filter(query: string): void {
    this.q = query;
    this._getPaginationParams(query);
    this.p = 1;
    this._getItems();
  }
}
